import { render } from "./EditAirport.vue?vue&type=template&id=a1229a46"
import script from "./EditAirport.vue?vue&type=script&lang=js"
export * from "./EditAirport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__